<template>
	<div>
		<div class="chat-item" :class="active ? 'active' : ''" @contextmenu.prevent="showRightMenu($event)">
			<div class="chat-left">
				<head-image :url="chat.headImage" :name="chat.showName" :size="45" :online="online"
					:id="chat.type == 'PRIVATE' ? chat.targetId : 0" :isShowUserInfo="false"></head-image>
				<div v-show="!chat.isDnd && chat.unreadCount > 0" class="unread-text">{{ chat.unreadCount }}</div>
			</div>
			<div class="chat-right">
				<div class="chat-name">
					<div class="chat-name-text" :title="chat.showName">{{ chat.showName }}</div>
					<div v-if="chat.companyName" class="company-tag-mini" :title="chat.companyName">@{{ chat.companyName
					}}</div>
					<div class="chat-tag">
						<el-tag v-if="chat.type == 'GROUP'" type="primary">群</el-tag>
						<el-tag v-if="chat.isTop" type="warning">顶</el-tag>
						<el-tag v-if="chat.type == 'SYSTEM'" type="danger">官方</el-tag>
					</div>
					<div class="chat-time-text">{{ showTime }}</div>
				</div>
				<div class="chat-content">
					<div class="chat-at-text">{{ atText }}</div>
					<div class="chat-send-name" v-show="isShowSendName">{{ chat.sendNickName + ':&nbsp;' }}</div>
					<div v-if="chat.draftText" class="chat-draft-text">[草稿]</div>
					<div v-if="chat.draftText" class="chat-content-text"
						v-html="$emo.transform($str.html2Escape(chat.draftText), 'emoji-small')"></div>
					<div v-else class="chat-content-text"
						v-html="$emo.transform($str.html2Escape(chat.lastContent), 'emoji-small')"></div>
					<div class="icon iconfont icon-dnd" v-if="chat.isDnd"></div>
				</div>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RightMenu from '../common/RightMenu.vue';

export default {
	name: "chatItem",
	components: {
		HeadImage,
		RightMenu
	},
	data() {
		return {}
	},
	props: {
		chat: {
			type: Object
		},
		active: {
			type: Boolean
		}
	},
	methods: {
		showRightMenu(e) {
			this.$refs.rightMenu.open(e, this.menuItems);
		},
		onSelectMenu(item) {
			this.$emit(item.key.toLowerCase(), this.msgInfo);
		}
	},
	computed: {
		isShowSendName() {
			if (!this.chat.sendNickName) {
				return false;
			}
			let size = this.chat.messages.length;
			if (size == 0) {
				return false;
			}
			// 只有群聊的普通消息需要显示名称
			let lastMsg = this.chat.messages[size - 1];
			return this.$msgType.isNormal(lastMsg.type)
		},
		showTime() {
			return this.$date.toTimeText(this.chat.lastSendTime, true)
		},
		atText() {
			if (this.chat.atMe) {
				return "[有人@我]"
			} else if (this.chat.atAll) {
				return "[@全体成员]"
			}
			return "";
		},
		menuItems() {
			let items = [];

			if (this.chat.type == 'PRIVATE' || this.chat.type == 'GROUP') {
				if (!this.chat.isTop) {
					items.push({
						key: 'TOP',
						name: '置顶'
					})
				} else {
					items.push({
						key: 'TOP',
						name: '取消置顶'
					})
				}
				items.push({
					key: 'INFO',
					name: '查看资料'
				});
				if (this.chat.isDnd) {
					items.push({
						key: 'DND',
						name: '新消息提醒'
					})
				} else {
					items.push({
						key: 'DND',
						name: '消息免打扰'
					})
				}
			}
			items.push({
				key: 'DELETE',
				name: '删除聊天',
				danger: true
			})
			return items;
		},
		online() {
			if (this.chat.type == 'PRIVATE') {
				let friend = this.friendStore.findFriend(this.chat.targetId);
				return friend && friend.online;
			}
			return false;
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-item {
	height: 60px;
	display: flex;
	position: relative;
	margin: 3px 6px;
	padding: 8px 12px;
	align-items: center;
	white-space: nowrap;
	cursor: pointer;
	border-radius: var(--radius-md);
	border: 0.5px solid transparent;
	transition:
		background 220ms ease,
		box-shadow 220ms ease,
		border-color 220ms ease,
		transform 220ms cubic-bezier(0.32, 0.72, 0, 1);

	&:hover:not(.active) {
		background:
			linear-gradient(135deg, rgba(91, 141, 238, 0.06), rgba(168, 139, 255, 0.04));
		box-shadow: inset 0 1px 0 0 rgba(255, 255, 255, 0.6);
	}

	// 选中: glass-active (§3.2 / §7.1) Aurora 蓝紫粉混合渐变 + 蓝细描边 + 内白高光
	&.active {
		background:
			linear-gradient(135deg, rgba(91, 141, 238, 0.18), rgba(168, 139, 255, 0.16) 55%, rgba(255, 175, 204, 0.12)),
			rgba(255, 252, 243, 0.82);
		border: 0.5px solid rgba(91, 141, 238, 0.45);
		box-shadow:
			inset 0 1px 0 0 rgba(255, 255, 255, 0.95),
			0 6px 16px rgba(91, 141, 238, 0.18),
			0 0 0 0.5px rgba(168, 139, 255, 0.12);

		// 左侧 Aurora 指示条 (柱)
		&::before {
			content: '';
			position: absolute;
			left: -6px;
			top: 50%;
			transform: translateY(-50%);
			width: 3px;
			height: 28px;
			border-radius: 2px;
			background: linear-gradient(180deg, var(--aurora-blue), var(--aurora-purple));
			box-shadow: 0 0 8px rgba(91, 141, 238, 0.45);
		}
	}

	.chat-left {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;

		// Aurora 粉色未读徽章
		.unread-text {
			position: absolute;
			background: linear-gradient(135deg, var(--aurora-pink), #FF6B8A);
			right: -4px;
			top: -6px;
			color: white;
			border-radius: 999px;
			padding: 1px 6px;
			font-size: 10px;
			font-weight: 600;
			text-align: center;
			white-space: nowrap;
			border: 1px solid rgba(255, 255, 255, 0.9);
			box-shadow: 0 2px 6px rgba(255, 107, 138, 0.4);
		}
	}

	.chat-right {
		flex: 1;
		display: flex;
		flex-direction: column;
		padding-left: 12px;
		text-align: left;
		overflow: hidden;

		.chat-name {
			display: flex;
			align-items: center;
			line-height: 24px;
			height: 24px;

			.chat-name-text {
				font-size: 15px;
				font-weight: 600;
				letter-spacing: -0.3px;
				color: var(--im-text-color);
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.chat-tag {
				flex: 1;
				display: flex;
				align-items: center;
				gap: 4px;
				margin-left: 6px;

				// §7.1 "顶" / "群" / "官方" 胶囊 tag (Aurora)
				:deep(.el-tag) {
					height: 16px;
					line-height: 14px;
					padding: 0 6px;
					font-size: 10px;
					font-weight: 600;
					letter-spacing: 0.2px;
					border-radius: 999px;
					border: 0.5px solid transparent;
				}

				// 群 → 蓝紫
				:deep(.el-tag--primary) {
					background: linear-gradient(135deg, rgba(91, 141, 238, 0.18), rgba(168, 139, 255, 0.16)) !important;
					color: var(--aurora-blue) !important;
					border-color: rgba(91, 141, 238, 0.32) !important;
				}
				// 顶 → 金色 (§4.2)
				:deep(.el-tag--warning) {
					background: linear-gradient(135deg, rgba(244, 213, 140, 0.36), rgba(212, 175, 106, 0.32)) !important;
					color: #8a6a25 !important;
					border-color: rgba(212, 175, 106, 0.55) !important;
					box-shadow: 0 0 8px rgba(212, 175, 106, 0.28);
				}
				// 官方 → 粉/红
				:deep(.el-tag--danger) {
					background: linear-gradient(135deg, rgba(255, 175, 204, 0.32), rgba(255, 107, 138, 0.28)) !important;
					color: #c5365e !important;
					border-color: rgba(255, 107, 138, 0.42) !important;
				}
			}

			.chat-time-text {
				font-size: 11px;
				text-align: right;
				color: var(--im-text-color-lighter);
				white-space: nowrap;
				overflow: hidden;
				padding-left: 4px;
				min-width: 60px;
				letter-spacing: 0;
				font-variant-numeric: tabular-nums;
			}
		}

		.chat-content {
			display: flex;
			align-items: center;
			line-height: 20px;
			height: 20px;
			margin-top: 2px;

			.chat-at-text {
				color: #FF3B30;
				font-size: 12px;
				font-weight: 700;
				letter-spacing: -0.1px;
				text-shadow: 0 0 6px rgba(255, 59, 48, 0.18);
				margin-right: 2px;
			}

			.chat-send-name {
				font-size: 12px;
				color: var(--im-text-color-lighter);
				letter-spacing: -0.1px;
			}

			.chat-draft-text {
				color: #FF3B30;
				font-size: 12px;
				margin-right: 4px;
				font-weight: 700;
				letter-spacing: -0.1px;
			}

			.chat-content-text {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: 12px;
				letter-spacing: -0.1px;
				color: var(--im-text-color-lighter);
			}

			.icon {
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 12px;
				color: var(--im-text-color-lighter);
				margin-left: 5px;
				background: rgba(31, 31, 35, 0.06);
				border-radius: 50%;
				width: 16px;
				height: 16px;
			}

		}
	}
}
</style>
